import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

// Define the type for the onPerfEntry callback
type OnPerfEntry = (metric: { [key: string]: any }) => void;

const reportWebVitals = (onPerfEntry?: OnPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
